// 📁 hooks/useCategoriaData.js - CORREGIDO
import { useState, useEffect } from "react";
import { apiService } from "../config/api";

export const useCategoriaData = () => {
  const [data, setData] = useState({
    categorias: [],
    representantes: [],
    asociaciones: [],
    departamentos: [],
    municipios: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllData = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Verificar si hay token antes de cargar representantes
      const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
      
      if (!token) {
        throw new Error('Debe iniciar sesión para acceder a esta información.');
      }

      // Usar apiService en lugar de fetch directo para mantener autenticación
      const [
        categoriasData,
        representantesData,
        asociacionesData,
        departamentosData,
        municipiosData
      ] = await Promise.all([
        apiService.categorias.getAll(),
        apiService.representantes.getAll(), // Ahora requiere token
        apiService.asociaciones.getAll(),
        apiService.geografia.getDepartamentos(),
        apiService.geografia.getMunicipios()
      ]);

      setData({
        categorias: categoriasData,
        representantes: representantesData,
        asociaciones: asociacionesData,
        departamentos: departamentosData,
        municipios: municipiosData
      });

      return {
        success: true,
        message: `Datos cargados: ${categoriasData.length} categorías, ${representantesData.length} representantes`
      };
    } catch (error) {
      // Manejo específico de errores de autenticación
      if (error.status === 401 || error.message.includes('401') || error.message.includes('Token no proporcionado')) {
        const authError = 'Sesión expirada. Por favor, inicie sesión nuevamente.';
        setError(authError);
        
        // Limpiar tokens inválidos
        sessionStorage.removeItem('authToken');
        localStorage.removeItem('authToken');
        
        throw new Error(authError);
      }
      
      setError(error.message);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return {
    ...data,
    isLoading,
    error,
    refetch: fetchAllData
  };
};